import { Pipe, PipeTransform } from "@angular/core";

@Pipe({ name: "avaregeFormat" })
export class AvaregeFormat implements PipeTransform {
	transform(value: number, type = 1): string {
		if (type === 1) {
			return `R$ ${value}`;
		} else {
			return `${value} %`;
		}
	}
}
